var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFloppy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.56 4.5 13.5.44A1.487 1.487 0 0 0 12.44 0H1.5A1.5 1.5 0 0 0 0 1.5v15A1.5 1.5 0 0 0 1.5 18h15a1.5 1.5 0 0 0 1.5-1.5V5.56a1.487 1.487 0 0 0-.44-1.06Zm-4.81 12h-7.5v-5.25h7.5v5.25Zm3.75 0h-2.25v-5.25a1.5 1.5 0 0 0-1.5-1.5h-7.5a1.5 1.5 0 0 0-1.5 1.5v5.25H1.5v-15h10.94l4.06 4.06V16.5ZM12 3.75a.75.75 0 0 1-.75.75H6A.75.75 0 0 1 6 3h5.25a.75.75 0 0 1 .75.75Z",
  fill: "#547D84"
})));
export default SvgFloppy;